module.exports = __webpack_public_path__ + "static/media/personafx_logo-white.c066c287.png";